import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ImportContainer } from '../../../Model/dataProcess/importContainer';
import { ImportContainerService } from '../../../Services/DataProcess/import-container.service';
import { LoginService } from '../../../Services/login.service';
import { Subscription } from 'rxjs';
import { SignalrService } from '../../../Services/signalr.service';
import { takeUntil } from 'rxjs/operators';
import {JobService} from "../../../Services/job.service";
import {Message} from "../../../Model/System/Message";
import {SystemService} from "../../../Services/system.service";
import {StartAction} from "../../../Model/Dto/StartAction";

@Component({
  selector: 'np-container-details',
  templateUrl: './container-details.component.html',
  styleUrls: ['./container-details.component.css']
})
export class ContainerDetailsComponent implements OnInit, OnDestroy {
  containerTitle = 'Katalog-Container';
  container?: ImportContainer | null;
  containerSearchText = '';
  isLoading = false;

  isImportPopupVisible = false;

  inspectContext: '' | 'containerDetails' | 'containerCatalog' = 'containerDetails';
  selectedCatalogId: string | null = null;

  private routeSub?: Subscription;

  constructor(
    private readonly translate: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly importContainerService: ImportContainerService,
    private readonly loginService: LoginService,
    private readonly signalrService: SignalrService,
    private readonly jobService: JobService,
    public systemService: SystemService,
  ) {}

  ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('id');
      if (id) {
        this.loadContainer(id);
      } else {
        this.container = null;
        this.containerTitle = this.translate.instant('Katalog-Container');
      }
    });

    this.signalrService.refreshCatalogList$
      .pipe(takeUntil(this.signalrService.clearSubscriptions$))
      .subscribe(async () => {
        const currentId =
          this.container?.id ?? this.route.snapshot.paramMap.get('id');

        if (currentId) {
          await this.loadContainer(currentId);
        }
      });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  private async loadContainer(id: string): Promise<void> {
    try {
      this.isLoading = true;
      this.container = null;

      const customerId = this.loginService.currentCustomer.id;
      const result = await this.importContainerService.get(id, customerId);
      this.container = result ?? null;

      this.containerTitle =
        this.container?.name || this.translate.instant('Katalog-Container');
    } catch (err) {
      console.error('Fehler beim Laden des Katalog-Containers', err);
      this.container = null;
      this.containerTitle = this.translate.instant('Katalog-Container');
    } finally {
      this.isLoading = false;
    }
  }

  openCreateCatalogsPopup(): void {
    this.isImportPopupVisible = true;
  }

  closeImportPopup(): void {
    this.isImportPopupVisible = false;
  }

  onSearchChanged(event: { value: string }): void {
    this.containerSearchText = (event?.value ?? '').trim();
  }

  async onContainerSaved(updated: ImportContainer): Promise<void> {
    const containerID =
      updated?.id ?? this.container?.id ?? this.route.snapshot.paramMap.get('id');
    if (containerID) {
      await this.loadContainer(containerID);
    }
  }

  async onImportCompleted(): Promise<void> {
    const containerID =
      this.container?.id ?? this.route.snapshot.paramMap.get('id');

    if (containerID) {
      await this.loadContainer(containerID);
    }

    this.isImportPopupVisible = false;
  }

  onInspectCatalogRequested(event: { container: ImportContainer; catalogId: string }): void {
    this.container = event.container;
    this.selectedCatalogId = event.catalogId;
    this.inspectContext = 'containerCatalog';
  }

  showContainerDetails(): void {
    this.inspectContext = 'containerDetails';
    this.selectedCatalogId = null;
  }

  startTransportCatalogFromImportToPreparationStageJob(): void {
    let startAction = new StartAction();
    startAction.customerId = this.loginService.currentUser.customerId;
    startAction.actionType = "TransportCatalogFromImportToPreparationStage";
    startAction.catalogId = this.selectedCatalogId;
    startAction.actionParameter = JSON.stringify({
      CatalogId: this.selectedCatalogId,
      ContainerId: this.container?.id
    })
    this.jobService.startUserAction(startAction).subscribe((success) => {
      if (success) {
        this.systemService.notify(new Message(this.translate.instant('Der Katalog wird transferiert.')));
      }
    });

  }
}
